var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"verifyFail"}},[_c('div',{staticClass:"title"},[_vm._v("人工申诉失败")]),_c('div',{staticClass:"cont"},[_vm._v("很抱歉，由于"+_vm._s(_vm.appeal_fail_reason)+"，您的人工申诉未通过。您可以联系客服。")]),_c('div',{staticClass:"btn",on:{"click":_vm.goAppeal}},[_vm._v("重新申诉")])])
}
var staticRenderFns = []

export { render, staticRenderFns }